module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="pubFicheField">\n    <div class="pubFicheFieldText">' +
((__t = (text)) == null ? '' : __t) +
'</div>\n</div>';

}
return __p
}